import UserService from './user.service'
import CarrierService from './carrier.service'
import CardService from './card.service'
import OrderService from './order.service'

export default {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $service: {
        get () {
          return {
            UserService: UserService.init(this),
            CarrierService: CarrierService.init(this),
            CardService: CardService.init(this),
            OrderService: OrderService.init(this)
          }
        }
      }
    })
  }
}
